<template>
  <div class="mask">
    <Button style="margin-right: 0.3rem;" type="bottom-btn" size="huge" @click="handleCreate"></Button>
    <Button type="primary" size="huge" @click="handleContribute">立即投稿</Button>
  </div>
</template>
<script setup lang="ts">
import { ApiModal } from "../../composables/apiModal";
import Button from "./common/button.vue";
import useDevice from "./common/useDevice";
import RaceModal from "./modal/raceModal.vue";
import CreateModal from "./modal/createModal.vue";
import { checkAuth } from "./checkPermission";
import kylogger from '@ky/sdk/dist/log/kylogger'
import open from "@ky/sdk/dist/open";

const raceModal = ref<ApiModal<any>>();
const createModal = ref<ApiModal<typeof CreateModal>>();

const { isMobile, isKyMobile } = useDevice();
const handleCreate = async () => {
  kylogger.collect('CLICK', 'CREATE_NOW', {});
  await checkAuth();
  if (isMobile.value) {
    open(
      `kwaiying://krn?bundleId=KyAIAggregation&componentName=AiHomeDetail&featureCode=aiGenVideo&toHotTop=0`,
    );
  } else {
    if (!createModal.value) {
      createModal.value = new ApiModal(CreateModal);
    }
    createModal.value.show();
  }
};
const handleContribute = async () => {
  kylogger.collect('CLICK', 'SUBMIT_NOW', {});

  await checkAuth();
  if (!raceModal.value) {
    raceModal.value = new ApiModal(RaceModal);
  }
  raceModal.value.show();
};


</script>

<style scoped lang="less">
.mask {
  z-index: 200;
  position: sticky;
  bottom: 0;
  padding-top: 30px;
  padding-bottom: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(to bottom,
      rgba(0, 0, 0, 0),
      rgba(0, 0, 0, 0.8),
      rgba(0, 0, 0, 1),
    );
}
</style>
